<template>
  <div class="banner" :class="[ isDarkMode ? `banner__background-${type}-${size} banner__background-${type}-${size}--dark` : `banner__background-${type}-${size}`]">
    <div class="banner__title" :class="[titleTextSize, isDarkMode ? `white--text` : `${contentTextColour}--text` ]">
      {{ title }}
    </div>
    <div class="banner__content" :class="[contentTextSize,  isDarkMode ? `white--text` : `${contentTextColour}--text` ]">
      <template v-if="contentText">{{ contentText }}</template>
      <slot v-else name="text" />
    </div>
    <div class="banner__cta">
      <slot name="button" />
    </div>
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: {
    type: { // create_org, add_user, add_app
      type: String,
      default: "create_org",
    },
    title: {
      type: String,
      default: "",
    },
    titleTextSize: {
      type: String,
      default: "hero-typography",
    },
    contentTextSize: {
      type: String,
      default: 'h3 font-weight-normal',
    },
    contentTextColour: {
      type: String,
      default: 'apioshade2',
    },
    contentText: {
      type: String,
      default: ``,
    },
    titleTextColour: {
      type: String,
      default: "apioshade2",
    },
    size: {
      type: String,
      default: 'wide',
    }
  },
  computed: {
    isDarkMode() {
      return this.$store.state.mode.darkMode
    }
  },
};
</script>

<style lang="scss" scoped src="./banner.scss">
